var $ = require('jquery');
var ko = require('knockout');
require('../lib/gmaps');

var self = {};

var $lastOpenedWindow = null;

function Pin(name, number) {
  var self = this;
  self.Name = name;
  self.PhoneNumber = number;
}

var map;
var opt = { minZoom: 2, maxZoom: 9 };
var markerImage = '/SiteFiles/Images/Icons/map-icon.png';

var onFranchiseLocations = function (data) {
  var $cultureCodeElem = $('[data-culture-code]');
  var $cultureCode = '';
  var $buttonText = '';
  if ($cultureCodeElem.length > 0) {
    $cultureCode = $cultureCodeElem.data('culture-code');
    $buttonText = $cultureCodeElem.data('button-text');
  }

  var useGenericMarker = true;
  var locations = data.Franchises;
  var markerBounds = new google.maps.LatLngBounds();
  if (locations.length) {
    if (locations.length <= 15) useGenericMarker = false;

    self.viewmodel.Pins.removeAll();
    map.removeMarkers();

    if (data.Longitude && data.Latitude) {
      map.addMarker({
        lat: data.Latitude,
        lng: data.Longitude,
      });
    }

    for (i = 0; i < locations.length; i++) {
      var location = locations[i];
      var image;
      if (useGenericMarker) {
        image = markerImage;
        location.Class = 'generic';
      } else {
        image = '/SiteFiles/Images/country/icons/icon' + (i + 1) + '.png';
        location.Class = 'circle' + (i + 1);
      }

      // Geberate a new position
      var position = new google.maps.LatLng(location.Latitude, location.Longitude);

      // Create Info window
      var contentString = '<div><h3>';

      if (location.URL) {
        contentString += '<a href="' + location.URL + '">';
      }
      contentString += location.Name;
      if (location.URL) {
        contentString += '</a>';
      }
      contentString += '</h3>';

      if (location.Address) {
        contentString += '<p>' + location.Address.replace(/\n/g, '<br>');
        if (location.PostCode) {
          contentString += '<br>' + location.PostCode;
        }
        contentString += '</p>';
      }
      if (location.PhoneNumber) {
        contentString +=
          '<a href="tel:' + location.PhoneNumber + '">' + location.PhoneNumber + '</a>';
      }
      // Social Media
      var $icon =
        location.MapFacebook || location.MapTwitter || location.MapLinkedIn || location.Email;
      if ($icon) {
        contentString += '<p>';
      }
      if (location.MapFacebook) {
        contentString +=
          '<a class="social-icon fa fa-facebook" href="' + location.MapFacebook + '"></a>';
      }
      if (location.MapTwitter) {
        contentString +=
          '<a class="social-icon fa fa-twitter" href="' + location.MapTwitter + '"></a>';
      }
      if (location.MapLinkedIn) {
        contentString +=
          '<a class="social-icon fa fa-linkedin" href="' + location.MapLinkedIn + '"></a>';
      }
      if (location.Email) {
        contentString +=
          '<a class="social-icon fa fa-envelope" href="mailto:' + location.Email + '"></a>';
      }
      if ($icon) {
        contentString += '</p>';
      }
      // /Social Media

      if (location.NotLink === false && location.URL.length) {
        contentString +=
          '<a class="btn--green btn--align button2 button2--ujarak btn--light" href="' +
          location.URL +
          '">' +
          $buttonText +
          '</a>';
      }

      // if(location.PhoneNumber){
      //   contentString += '<p><a href="tel:' + location.PhoneNumber + '">' + location.PhoneNumber + '</a></p>';
      // }
      // if(location.Email){
      //   contentString += '<p><a href="mailto:' + location.Email + '">' + location.Email + '</a></p>';
      // }
      contentString += '</div>';

      var infoWindow = new google.maps.InfoWindow({
        content: contentString,
      });

      // Add the marker
      var marker = map.addMarker({
        position: position,
        icon: image,
      });

      makeInfoWindowEvent(map, infoWindow, contentString, marker);

      addStyleToInfoWindow(infoWindow);

      // Extend the marker bounds
      //markerBounds.extend(position);
      if ($cultureCode.length === 0 || location.CultureCode == $cultureCode) {
        self.viewmodel.Pins.push(location);
      }
    }
    // Finally move to the markerBounds
    //map.fitBounds(markerBounds);

    // Close last infoWindow on Map click
    map.addListener('click', function () {
      if ($lastOpenedWindow) {
        $lastOpenedWindow.close();
      }
    });
    // Remove one level of zoom to ensure all markers are on the viewport
    //map.setZoom(map.getZoom()-1);
  }
}; //End onFranchiseLocations

self.viewmodel = {};

self.viewmodel.Location = ko.observable();

self.viewmodel.Pins = ko.observableArray();

self.viewmodel.allLocations = function (data) {
  GMaps.geolocate({
    success: function (position) {
      $.get(
        '/api/franchise/' + position.coords.latitude + '/' + position.coords.longitude,
        null,
        onFranchiseLocations
      );
    },
    error: function (error) {
      $.post('/api/franchise', null, onFranchiseLocations);
    },
    not_supported: function () {
      $.post('/api/franchise', null, onFranchiseLocations);
    },
  });
  ko.applyBindings(self.viewmodel, $target[0]);
};

self.viewmodel.searchFor = function () {
  if (self.viewmodel.Location().length) {
    $.get('/api/franchise/' + self.viewmodel.Location(), null, onFranchiseLocations);
  }
  return false;
};

var ResetMapToCountryView = function () {
  var $countryElem = $('[data-country-name]');

  if ($countryElem.length > 0) {
    var countryName = $countryElem.data('country-name');

    if (countryName.length > 0) {
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: countryName }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          map.setCenter(results[0].geometry.location.lat(), results[0].geometry.location.lng());
          map.fitBounds(results[0].geometry.viewport);
        }
      });
    }
  }
};

var makeInfoWindowEvent = function (map, infowindow, contentString, marker) {
  google.maps.event.addListener(marker, 'click', function () {
    if ($lastOpenedWindow) {
      $lastOpenedWindow.close();
    }
    infowindow.setContent(contentString);
    infowindow.open(map, marker);
    $lastOpenedWindow = infowindow;
  });
  // close window on map click
  google.maps.event.addListener(map, 'click', function () {
    infowindow.close();
  });
};

var addStyleToInfoWindow = function (infowindow) {
  google.maps.event.addListener(infowindow, 'domready', function () {
    var iwOuter = $('.gm-style-iw');
    var iwBackground = iwOuter.prev();
  });
};

self.init = function ($target) {
  ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewmodel) {
      var callback = valueAccessor();
      $(element).keypress(function (event) {
        var keyCode = event.which ? event.which : event.keyCode;
        if (keyCode === 13) {
          callback.call(viewmodel);
          return false;
        }
        return true;
      });
    },
  };

  map = new GMaps({
    div: '#map-canvas',
    lat: 54.5110481,
    lng: -4.0550972,
    zoom: 6,
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    navigationControl: true,
    navigationControlOptions: {
      style: google.maps.NavigationControlStyle.SMALL,
    },
  });
  map.setOptions(opt);

  $('#inpLocation').keypress(function (e) {
    if (e.which == 13) {
      GMaps.geolocate({
        success: function (position) {
          if (self.viewmodel.Location().length === 0) {
            map.setCenter(position.coords.latitude, position.coords.longitude);
          }
        },
        error: function (error) {
          alert('Geolocation failed: ' + error.message);
        },
        not_supported: function () {
          alert('Your browser does not support geolocation');
        },
      });
    }
  });

  var styles = [
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#444444' }],
    },
    { featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
    { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [{ saturation: -100 }, { lightness: 45 }],
    },
    { featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    { featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [{ color: '#46bcec' }, { visibility: 'on' }],
    },
  ];

  // Add addtional map styling
  map.addStyle({
    styledMapName: 'InXpress Map',
    styles: styles,
    mapTypeId: 'map_style',
  });

  // Set the map style
  map.setStyle('map_style');

  $.post('/api/franchise', null, onFranchiseLocations);

  ResetMapToCountryView();

  ko.applyBindings(self.viewmodel, $target[0]);
}; //End init

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/googleFind.js